/// <amd-module name="Environments/Providers/VirtualMachineGroups/Services/VirtualMachineGroupExtendedClient" />
import { IVssService, Services, VssService, IVssRestClient, RestClients } from "VSS/Platform/Context";
import { RestClientBase } from "VSS/Platform/RestClientBase";
import { deserializeVssJsonObject } from "VSS/Platform/Util/Serialization";

import {
    VirtualMachineGroup,
    VirtualMachine
} from "DistributedTask/Client/Contracts/TaskAgent";


export interface IVirtualMachineGroupTargetsResult {
    virtualMachines: VirtualMachine[];
    continuationToken: string | undefined;
}

export interface IVirtualMachineGroupsExtendedClient extends IVssRestClient{
    getVirtualMachineGroupTargetsWithContinuationToken(project: string, environmentId: number, resourceId: number, continuationToken?: string, top?: number): Promise<IVirtualMachineGroupTargetsResult>;
    getVirtualMachineGroupTargetsWithContinuationTokenNewClient(project: string, environmentId: number, resourceId: number, continuationToken?: string, top?: number): Promise<IVirtualMachineGroupTargetsResult>;
}

class VirtualMachineGroupsExtendedClient extends RestClientBase implements IVirtualMachineGroupsExtendedClient {
    public async getVirtualMachineGroupTargetsWithContinuationToken(project: string, environmentId: number, resourceId: number, continuationToken?: string, top?: number): Promise<IVirtualMachineGroupTargetsResult> {
        const queryValues: any = {
            environmentId: environmentId,
            resourceId: resourceId,
            continuationToken: continuationToken,
            '$top': top
        };

        return this.beginRequest<Response>({
            apiVersion: "5.0-preview.1",
            routeTemplate: "{project}/_apis/distributedtask/environments/{environmentId}/providers/virtualmachinegroups/{resourceId}/virtualmachines",
            routeValues: {
                project: project,
                environmentId: environmentId,
                resourceId: resourceId
            },
            queryParams: queryValues,
            returnRawResponse: true,
        }).then(async response => {
            let virtualMachines = await response.text().then(deserializeVssJsonObject) as VirtualMachine[];
            return { virtualMachines: virtualMachines, continuationToken: this._getContinuationToken(response) } as IVirtualMachineGroupTargetsResult;
        });
    }

    public async getVirtualMachineGroupTargetsWithContinuationTokenNewClient(project: string, environmentId: number, resourceId: number, continuationToken?: string, top?: number): Promise<IVirtualMachineGroupTargetsResult> {
        const queryValues: any = {
            environmentId: environmentId,
            resourceId: resourceId,
            continuationToken: continuationToken,
            '$top': top
        };

        return this.beginRequest<Response>({
            apiVersion: "5.2-preview.1",
            routeTemplate: "{project}/_apis/pipelines/environments/{environmentId}/providers/virtualmachinegroups/{resourceId}/virtualmachines",
            routeValues: {
                project: project,
                environmentId: environmentId,
                resourceId: resourceId
            },
            queryParams: queryValues,
            returnRawResponse: true,
        }).then(async response => {
            let virtualMachines = await response.text().then(deserializeVssJsonObject) as VirtualMachine[];
            return { virtualMachines: virtualMachines, continuationToken: this._getContinuationToken(response) } as IVirtualMachineGroupTargetsResult;
        });
    }

    private _getContinuationToken(response: Response): string | undefined {
        return response.headers.get("x-ms-continuationtoken") || undefined;
    }
}

RestClients.add("IVirtualMachineGroupsExtendedClient", {
    factory: VirtualMachineGroupsExtendedClient,
    options: {
        serviceInstanceType: "00025394-6065-48ca-87d9-7f5672854ef7",
    }
});